{
  "header": "<h2>{{name}}, here is your offer for the purchase of <payment />!</h2>",
  "header-expired": {
    "name": "<h2>{{name}}, do you need time to decide?</h2>",
    "no-name": "<h2>Do you need time to decide?</h2>"
  },
  "subheader": "An initial payment is due today, then pay the remaining balance in monthly installments.",
  "subheader-zero-down": "$0 due today! Then pay the total balance in monthly installments.",
  "inputs-header": "Billing Details",
  "required-fields": "All fields required",
  "select-payment-method": "Select payment method",
  "payment-option": {
    "debit": "Debit card",
    "bank-account": "Add your bank account",
    "bank-account-desc": "Connect your bank account for more convenience and reliability. Set it and forget it!",
    "credit": "Credit Card"
  },
  "payment-faq-button": "What are my payment method options?",
  "select-payment-method-error": "You must select a payment method",
  "plaid-locked-error": "Please select a different payment method.",
  "plaid-link-token-error": "Oops! Something went wrong. Please try again or select a different payment method.",
  "recommended": "Recommended",
  "offerSelector": {
    "srOnly": {
      "multipleOfferSelectedTitle": "Selected Installment Payment Offer {{index}}",
      "multipleOfferTitle": "Installment Payment Offer {{index}}",
      "singleOfferTitle": "Installment Payment Offer",
      "apr": "A P R ",
      "remainingPayments": "Remaining number of payments: "
    },
    "perMonth": " /month",
    "monthly": "monthly",
    "zeroDown": "$0 due today!",
    "payToday": "+ down payment today of <downPayment />",
    "apr": "APR",
    "interest": "Interest",
    "total": "Total",
    "months": " months",
    "tooltip": "<div>Your downpayment of <strong><pureDownPayment /> today</strong> will be followed by <strong>{{numberOfPayments}} monthly installments</strong></div>",
    "deferredPayment": {
      "text": "First installment Jan 2023",
      "mobile": {
        "firstInstallment": "First installment",
        "date": "Jan 2023"
      }
    },
    "zeroAPRLabel": "0% APR",
    "lowestPaymentLabel": "Lowest Monthly Payment"
  },
  "inputs": {
    "card-info-name": {
      "isRequired": true,
      "label": "Cardholder Name*",
      "validity": [
        ["required", "Cardholder Name is required", "ignore label"],
        ["minLength1", "Enter name as it appears on card", "ignore label"]
      ]
    },
    "card-info-number": {
      "isRequired": true,
      "label": "Card Number*",
      "validity": [
        ["isValidCardNumberEn", "Invalid Card Number", "ignore label"]
      ]
    },
    "card-info-expiration": {
      "isRequired": true,
      "label": "Exp*",
      "mask": "99/99",
      "maxLength": 6,
      "format": "mmyyyy",
      "placeholder": "MM/YY",
      "srOnly": "M M Y Y",
      "validity": [["isValidCardExpiration", "Invalid Date", "ignore label"]]
    },
    "card-info-ccv": {
      "label": "CVV*",
      "isRequired": true,
      "tooltip": "<div>3 or 4-digit number located on the back of the card.</div>",
      "validity": [["isValidCardCCV", "Invalid code", "ignore label"]]
    },
    "billing-zip": {
      "label": "Postal code",
      "isRequired": true,
      "mask": "X9X 9X9",
      "validity": [["isValidCardZip", "Invalid postal code", "ignore label"]]
    },
    "autopay": {
      "isRequired": true,
      "validity": []
    }
  },
  "autopay": {
    "label": "Enable AutoPay",
    "content": "<span>AutoPay is an easy and convenient way to make your monthly loan payments.</span>",
    "modalContent": {
      "header": "Are you sure?",
      "body": "AutoPay is a convenient and simple way to make your monthly loan payments and helps ensure you don’t have an extra interest expense from late payments.",
      "keep": "Keep AutoPay",
      "disable": "Disable AutoPay"
    }
  },
  "edit": "Edit",
  "uplift": {
    "terms": "Terms and conditions offered by Uplift Canada Services ULC."
  },
  "submit": "Continue",
  "flexpay": {
    "terms": "Terms and conditions offered by Uplift Canada Services ULC.",
    "offerSelector": {
      "delayedPayments": {
        "multi": "Payments start in {{months}} months",
        "single": "Payments start in {{months}} month"
      }
    }
  },
  "splitOfferSelector": {
    "selectedOffer": {
      "dueToday": "Due Today",
      "interestWithAPR": "Interest (<APRComponent/> APR)",
      "selectedOffer": "Selected Offer"
    },
    "changePaymentPlan": {
      "paymentPlan": "Payment Plan",
      "change": "Change"
    }
  }
}
